import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const PlusIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z'
                fill='currentColor'
            />
        </>
    ),
})

PlusIcon.displayName = 'PlusIcon'
